import { STATUS_CANDIDATE } from './ManagerCandidate';

export const USE_GET_LIST_MAIL_TEMPLATE = 'USE_GET_LIST_MAIL_TEMPLATE';
export const USE_GET_MAIL_PLACEHOLDERS = 'USE_GET_MAIL_PLACEHOLDERS';
export const USE_GET_MAIL_LOGS = 'USE_GET_MAIL_LOGS';
export const USE_GET_MAIL_RECIPIENT = 'USE_GET_MAIL_RECIPIENT';

// Khớp MailTemplateEnum bên acms_recruit_service
export const TRIGGER_TYPE = {
  APPLY_STATUS: 1,
  INTERVIEW_UPDATED: 2,
  MANUAL: 3,
};

export const SEND_MODE = {
  AUTO: 1,
  CONFIRM: 2,
  MANUAL: 3,
};

export const MAIL_ACTIVE = 1;
export const MAIL_INACTIVE = 0;

export const MAIL_LOG_STATUS = {
  PENDING: 1,
  SENDING: 2,
  SENT: 3,
  FAILED: 4,
  CANCELLED: 5,
};

// Chỉ log lỗi/huỷ mới gửi lại được
export const MAIL_LOG_CAN_RESEND = [MAIL_LOG_STATUS.FAILED, MAIL_LOG_STATUS.CANCELLED];

// Trạng thái apply được phép gắn mẫu — giống MailTemplateEnum::LIST_TRIGGER_STATUS
export const LIST_TRIGGER_STATUS = [
  STATUS_CANDIDATE.FAIL_PRE_QUALIFICATION,
  STATUS_CANDIDATE.PASS_PRE_QUALIFICATION,
  STATUS_CANDIDATE.CANCEL_CV,
  STATUS_CANDIDATE.WAIT_CANDIDATE_RESPONSE,
  STATUS_CANDIDATE.WAITING_INTERVIEW,
  STATUS_CANDIDATE.LEADER_CANCEL_INTERVIEW,
  STATUS_CANDIDATE.HR_CANCEL_INTERVIEW,
  STATUS_CANDIDATE.LEADER_REFUSE_CANDIDATE,
  STATUS_CANDIDATE.WAITING_CANDIDATE_RESPONSE_OFFER,
  STATUS_CANDIDATE.CANDIDATE_AGREE_OFFER,
  STATUS_CANDIDATE.ONBOARD,
];

export const MAX_DELAY_MINUTES = 43200;
export const MAX_LENGTH_MAIL_SUBJECT = 255;
